<template>
    <div class="frame-card">
        <div
            class="item-card"
            v-for="(item, index) in ChuyenDiCuaLaiXe.DanhSachTieuChiSapXep"
            :key="index"
            @click="SapXep(item, index)"
            :class="item.order != 0 ? 'active' : ''"
        >
            <i
                class="mdi mdi-swap-vertical mr-1"
                style="font-size: 16px"
                v-if="item.order == 0"
            ></i>
            <i
                class="mdi mdi-sort-bool-ascending mr-1"
                style="font-size: 16px"
                v-if="item.order == 1"
            ></i>
            <i
                class="mdi mdi-sort-bool-descending mr-1"
                style="font-size: 16px"
                v-if="item.order == 2"
            ></i>
            {{ item.text }}
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    computed: {
        ChuyenDiCuaLaiXe: {
            get() {
                return this.$store.state.BaoCao.ChuyenDiCuaLaiXe;
            },
            set(data) {
                this.$store.commit("BaoCao/Set", {
                    key: "ChuyenDiCuaLaiXe",
                    data: data,
                });
            },
        },
    },
    methods: {
        SapXep(item, index) {
            this.ChuyenDiCuaLaiXe.DanhSachTieuChiSapXep.forEach((e, i) => {
                if (index != i) {
                    e.order = 0;
                    e.kieuSapXep = "";
                }
            });

            if (this.ChuyenDiCuaLaiXe.DanhSachTieuChiSapXep[index].order < 2) {
                this.ChuyenDiCuaLaiXe.DanhSachTieuChiSapXep[index].order++;
            } else {
                this.ChuyenDiCuaLaiXe.DanhSachTieuChiSapXep[index].order = 0;
            }
            let order = this.ChuyenDiCuaLaiXe.DanhSachTieuChiSapXep[index].order;
            this.ChuyenDiCuaLaiXe.DanhSachTieuChiSapXep[index].kieuSapXep =
                order == 0 ? "" : order == 1 ? "ASC" : order == 2 ? "DESC" : "";

            this.$emit("TimKiemChuyenDi", {});
        },
    },
};
</script>

<style scoped>
.frame-card {
    width: 100%;
    overflow-x: scroll;
    display: flex;
    align-items: center;
    margin: 0 8px;
}
.frame-card::-webkit-scrollbar {
    display: none;
}
.item-card {
    border: 1px solid #dadce0;
    margin-right: 8px;
    border-radius: 24px;
    padding: 4px 12px 4px 8px;
    width: auto;
    height: 36px;
    display: flex;
    align-items: center;
    white-space: nowrap;
    box-shadow: inset 0 0 5px #dadce0;
}
.item-card.active {
    border: 1px solid #03a9f4;

    box-shadow: inset 0 0 5px #03a9f4;
    color: #03a9f4;
}
</style>
